import GalleryPage from "./GalleryPage";

export default GalleryPage;
